
export enum RiskNoticeStatusValue {
  Waiting = 'waiting',
  Accepted = 'accepted',
  Rejected = 'rejected',
}